import React from "react";

import Common from "./Common";
const TransferDetail = (props) => {
  return (
    <>
      <Common {...props} />
    </>
  );
};

export default TransferDetail;
